//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import { sync } from 'vuex-pathify'
import { ContentType } from '@constants'
import routeUtils from '../utils/route'
import Content from '../components/blocks/Content.vue'
import LoginForm from '../components/auth/LoginForm.vue'
import ArticlesPage from '../components/article/ArticlesPage.vue'
import ArticleContent from '../components/article/ArticleContent.vue'
import NewsletterSubscriptions from '../components/blocks/NewsletterSubscriptions.vue'
import UserSubscriptions from '../components/blocks/UserSubscriptions.vue'
import Dossier from '../components/blocks/Dossier.vue'
import EmptyLine from '../components/blocks/EmptyLine.vue'
import Grid from '~/components/blocks/Grid.vue'
import CustomScript from '~/components/blocks/CustomScript.vue'

const PAGES = `
          query GetPage($slug: String) {
            pages(locale: "all", filters: { slug: { eqi: $slug } }, publicationState: PREVIEW) {
              ${routeUtils.STRAPI_QUERY}
            }
          }
        `

// Article/dossier/job links are always built as /<contentType>/<slug>--<externalId>
// (see ArticlePreviewCard, LiveBlogSummaryBlock, etc.), a shape Strapi page slugs never use.
// Matching it here lets us skip the uncached PREVIEW lookup for the majority of catch-all traffic.
const ARTICLE_PATH_REGEX = /^\/[^/]+\/[^/]+--\d+$/

export default {
  components: {
    Content,
    LoginForm,
    NewsletterSubscriptions,
    ArticlesPage,
    ArticleContent,
    EmptyLine,
    Dossier,
    Grid,
    CustomScript,
    UserSubscriptions
  },
  beforeRouteLeave(to, from, next) {
    this.$store.set('app/isStrapiPage', false)

    next()
  },
  async asyncData({ params, payload, $config, app, store }) {
    if (payload) return { page: payload }

    let slug = params.pathMatch.endsWith('/') ? `/${params.pathMatch}`.slice(0, -1) : `/${params.pathMatch}`
    const isNl = slug === '/nl'
    const isNld = slug.startsWith('/nld')

    // set language early for /nl or /nld routes so child components fetch Dutch content
    if (isNl || isNld) {
      app.i18n.setLocale('nl')
      store.set('language/locale', 'nl')
    }

    slug = isNld ? slug.slice(4) : slug

    if (ARTICLE_PATH_REGEX.test(slug)) {
      return { page: null }
    }

    const { data } = await axios.post(
      $config.graphQlStrapiApi,
      {
        query: PAGES,
        variables: {
          slug
        }
      },
      {
        headers: {
          Authorization: `Bearer ${$config.strapiApiToken}`
        }
      }
    )

    const nldPage = data.data.pages.data.find((page) => page.attributes.locale === 'nl')
    const engPage = data.data.pages.data.find((page) => page.attributes.locale === 'en')

    if (isNld && nldPage) {
      return { page: nldPage }
    }

    if (!isNld && engPage) {
      return { page: engPage }
    }

    if (nldPage) {
      return { page: nldPage }
    }

    return { page: engPage }
  },
  data() {
    return {
      ContentType
    }
  },
  head() {
    if (!this.isStrapiPage) {
      return { title: 'Telecompaper', meta: [] }
    }

    const title = this.seo?.metaTitle || this.title || ''
    const description = this.seo?.metaDescription || ''
    const viewport = this.seo?.metaViewport || null
    const robots = this.seo?.metaRobots || null
    const keywords = this.seo?.keywords || null

    // Handle image URL (ensure absolute URL)
    const rawImageUrl = this.seo?.metaImage?.data?.attributes?.url
    let image = null
    if (rawImageUrl) {
      if (rawImageUrl.startsWith('http')) {
        image = rawImageUrl
      } else {
        image = this.$config.baseURL + rawImageUrl
      }
    }

    const canonical = this.$config.baseURL + this.$route.fullPath

    const meta = [
      viewport && { name: 'viewport', content: viewport },
      description && { hid: 'description', name: 'description', content: description },
      robots && { hid: 'robots', name: 'robots', content: robots },
      keywords && { hid: 'keywords', name: 'keywords', content: keywords },

      // Open Graph tags
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:site_name', property: 'og:site_name', content: 'Telecompaper' },
      { hid: 'og:title', property: 'og:title', content: title },
      { hid: 'og:url', property: 'og:url', content: canonical },
      description && { hid: 'og:description', property: 'og:description', content: description },
      image && { hid: 'og:image', property: 'og:image', content: image },

      // Twitter Card tags
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { hid: 'twitter:title', name: 'twitter:title', content: title },
      description && { hid: 'twitter:description', name: 'twitter:description', content: description },
      image && { hid: 'twitter:image', name: 'twitter:image', content: image }
    ].filter(Boolean)

    return {
      title,
      meta,
      link: [{ rel: 'canonical', href: canonical }]
    }
  },
  computed: {
    filters: sync('filters'),
    seo() {
      return this.page ? this.page.attributes.seo : undefined
    },
    meta() {
      return this.page && this.page.attributes.metaData ? this.page.attributes.metaData : {}
    },
    account() {
      return this.$store.get('user/user') || null
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    slug() {
      return this.$route.path
    },
    isStrapiPage() {
      return !!this.page
    },
    isDossierPage() {
      return this.blocks.filter((x) => x.__typename === 'ComponentBlocksDossier').length > 0
    },
    blocks() {
      return this.page ? this.page.attributes.blocks : []
    },
    sideBarBlocks() {
      return this.page && this.page.attributes.sideBar ? this.page.attributes.sideBar : []
    },
    title() {
      return this.page ? this.page.attributes.title : ''
    },
    slugParts() {
      return this.$route.path.split('/').filter(Boolean)
    }
  },
  watch: {
    language(value) {
      if (!this.isStrapiPage) {
        return
      }

      const isNld = this.slug.startsWith('/nld')

      if (!isNld && value === 'nl') {
        this.$router.replace({ path: '/nld' + this.slug })
        return
      }

      if (isNld && value === 'en') {
        this.$router.replace({ path: this.slug.slice(4) })
      }
    }
  },
  async beforeMount() {
    // setting flag to be used in other pages
    this.$store.set('app/isStrapiPage', this.isStrapiPage)

    if (this.isStrapiPage && typeof window !== 'undefined') {
      this.setBreadcrumb({})
      this.setFilters({})
    }

    if (this.seo?.structuredData) {
      const newScript = document.createElement('script')
      newScript.type = 'application/ld+json'
      newScript.innerText = JSON.stringify(this.seo.structuredData)

      document.head.appendChild(newScript)
    }

    if (!this.isStrapiPage && this.slugParts.length > 2) {
      return this.$nuxt.error({ statusCode: 404, message: 'Page Not Found' })
    }

    const isNld = this.slug.startsWith('/nld')
    if (this.isStrapiPage && isNld && this.language !== 'nl') {
      this.$i18n.setLocale('nl')
      this.$store.set('language/locale', 'nl')
    } else if (this.isStrapiPage && !isNld && this.language !== 'en') {
      this.$i18n.setLocale('en')
      this.$store.set('language/locale', 'en')
    }

    const clientId = this.meta.clientId
    if (!this.isStrapiPage || !clientId) {
      return
    }

    if (!this.account) {
      this.$router.replace({ path: '/client/login/' })
      return
    }

    const { data } = await this.$axios.post(`/client/${clientId}/VerifyUser`)
    if (!data.verified) {
      this.$router.replace({ path: '/client/login/' })
    }
  },
  methods: {
    isBlockVisible(block) {
      if (!block) {
        return false
      }
      if (!block.displayRules) {
        return true
      }
      if (block.displayRules.authentication === 'Both') {
        return true
      }
      if (this.account && block.displayRules.authentication === 'Authenticated_Only') {
        return true
      }
      if (!this.account && block.displayRules.authentication === 'Unauthenticated_Only') {
        return true
      }
      return false
    },
    getContentTypeId(block) {
      const contentType = block.contentType ?? block.genericArticleContentType

      switch (contentType) {
        case 'News':
          return ContentType.NEWS
        case 'Background':
          return ContentType.BACKGROUND
        case 'Commentary':
          return ContentType.COMMENTARY
        case 'PressRelease':
          return ContentType.PRESS_RELEASE
        case 'Advertorial':
          return ContentType.ADVERTORIAL
        case 'WhitePaper':
          return ContentType.WHITE_PAPER
        case 'Profile':
          return ContentType.PROFILE
        case 'Report':
          return ContentType.REPORT
        case 'CompanyProfile':
          return ContentType.COMPANY_PROFILE
        case 'Brief':
          return ContentType.BRIEF
        case 'Chart':
          return ContentType.CHART
        default:
          return ContentType.BACKGROUND
      }
    }
  }
}
